import { observer } from "mobx-react-lite";
import { useState } from "react";

import { useStores } from "../../stores/useStores";
import { FieldLabel } from "../ui/controls";
import { Dialog } from "../ui/Dialog";
import { TextField } from "../ui/TextField";

/** Makes a new, empty setlist. */
export const NewSetlistDialog = observer(function NewSetlistDialog({ onClose }: { onClose(): void }) {
    const { library, navigation } = useStores();
    const [name, setName] = useState("");
    const [date, setDate] = useState("");

    async function create() {
        const setlist = await library.change((l) => l.createSetlist(name.trim(), date || undefined));

        onClose();
        navigation.go({ name: "setlists", setlistId: setlist.id });
    }

    return (
        <Dialog title="New setlist" submit="Create" canSubmit={!!name.trim()} onSubmit={create} onClose={onClose}>
            <FieldLabel>
                Name
                <TextField autoFocus placeholder="Like Sunday 1 November" value={name} onChange={setName} />
            </FieldLabel>
            <FieldLabel>
                Date (optional)
                <TextField type="date" value={date} onChange={setDate} />
            </FieldLabel>
        </Dialog>
    );
});
